var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-box"},[_c('headerTop',{attrs:{"title":_vm.agreement.title}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.agreement.content)}}),_c('div',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('footBottom',{attrs:{"title":"知道了"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }